import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const BytElbolag = lazy(() => import("@/pages/elbolag/BytElbolag"));

export const Route = createFileRoute("/elbolag/byt")({
  head: () => seoHead("/elbolag/byt"),
  component: () => <BytElbolag />,
});
